//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { iconAliases } from '@bvengineering/unison-core';
import type { ComponentType, SVGProps } from 'react';

import { isDefined } from '@utils/filterPredicates';

export type SvgComponent = ComponentType<SVGProps<SVGSVGElement>>;

// Glob all SVGs recursively from unison-core icons (brands/, custom/, regular/, solid/)
const svgContext = require.context(
  '@bvengineering/unison-core/lib/icons',
  true,
  /\.svg$/,
);

// Build a map of file path -> React component (e.g., 'solid/circle-plus' -> Component)
const svgByPath: Record<string, SvgComponent> = Object.fromEntries(
  svgContext.keys().map((key: string) => {
    const path = key.replace('./', '').replace('.svg', '');
    const mod: { default: SvgComponent } = svgContext(key) as {
      default: SvgComponent;
    };
    return [path, mod.default];
  }),
);

// Resolve alias names to components using iconAliases (e.g., 'add' -> Component)
// Also include direct path-based names so both conventions work.
export const iconMap = Object.entries(iconAliases).reduce<
  Record<string, SvgComponent>
>(
  (map, [name, path]) => {
    if (isDefined(svgByPath[path])) {
      map[name] = svgByPath[path];
    }
    return map;
  },
  { ...svgByPath },
);
